module.exports = __webpack_public_path__ + "img/sample-m-2.5068d943.jpeg";